import React from 'react';
import styled from 'styled-components/macro';
import * as colors from 'src/styles/colors';
import { mobilePoint } from 'src/styles/globalStyle';

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 4fr;
  gap: 1.5em;
  background-color: ${colors.white};
  box-shadow: 0 0 5px rgba(67, 67, 67, 0.08);
  width: 100%;
  border-radius: 4px;
  padding: 2em;

  @media (max-width: ${mobilePoint}) {
    grid-template-columns: 1fr;
  }
`;
const Title = styled.div`
  text-align: left;
  @media (max-width: ${mobilePoint}) {
    font-family: NotoSansTC-Bold;
  }
`;
const Content = styled.div<{ isSubmitting:boolean, isChecked: boolean }>`
  font-size: large;
  display: flex;
  gap: 0.5em;
  color: ${(prop) => (prop.isSubmitting ? colors.black : prop.isChecked ? colors.primaryGreen_500 : colors.notice_error)};
`;

interface IProps {
  title?: string;
  isSubmitting: boolean;
  isChecked: boolean;
  children: React.ReactNode;
}
/**
 * 電子證書回傳結果區塊
 */
const CertificateResult: React.FC<IProps> = ({ title, isSubmitting, isChecked, children }) => {
  return (
    <Wrapper>
      {title && <Title>{title}</Title>}
      <Content isSubmitting={isSubmitting} isChecked={isChecked}>{children}</Content>
    </Wrapper>
  );
};

export default CertificateResult;
